export default {
  issueKitchenTitle: "Issue to Kitchen",
  issueKitchenSubtitle: "Distribute ingredients for daily operations",
  loadingInventory: "Loading inventory...",
  item: "Item",
  available: "Available",
  issueQty: "Issue Qty",
  action: "Action",
  remarks: "Remarks",
  remarksPlaceholder: "Optional notes for kitchen staff",
  items: "items",
  qty: "qty",
  issueKitchenButton: "Issue to Kitchen",
  issuingNow: "Issuing...",
  cancel: "Cancel",
  issueAtLeastOne: "Please issue at least one item",
  issueFailed: "Failed to issue items"
};